<div fxLayout="row" fxLayoutAlign="space-between start">
  <span class="white-fg">
    {{data.msg}}
  </span>
  <button matTooltip="Close message"mat-icon-button aria-label="Close Message" (click)="close()">
    <mat-icon class="white-fg">close</mat-icon>
  </button>
</div>